import { Box, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { EventFormStatus, FormMetadata } from '../../core/api/clients';
import { getColor } from '../../core/colors';
import SafetyEventList from './SafetyEventList';
import SafetyEventDrafts from './SafetyEventDrafts';
import useGetFormMetadata from '../../core/api/hooks/common/useGetFormMetadata';

function SafetyEventLanding({ formMetadata }:{ formMetadata: FormMetadata }) {
  if (!formMetadata || !(formMetadata.contributeRole)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { data: authorizedForm } = useGetFormMetadata(formMetadata.componentName ?? '');
  if (!authorizedForm) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const color = getColor(formMetadata.color)[500];
  return (
    <React.Fragment>
      {authorizedForm.isContributor && (
        <React.Fragment>
          <Grid container direction="column">
            <Typography variant="h6" sx={{ mb: 0, color, fontWeight: 300 }}>
              All Drafts
            </Typography>
            <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
              <SafetyEventDrafts />
            </Paper>
          </Grid>
          <Box sx={{ mt: 2 }} />
        </React.Fragment>
      )}
      <Grid container direction="column">
        <Typography variant="h6" sx={{ mb: 0, color, fontWeight: 300 }}>
          Safety Event Forms (Last 7 days)
          <Tooltip title="This section shows the forms from the last 7 days using the date the report was created.">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Typography>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <SafetyEventList
            hours={168}
            statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
            pageSize={10}
          />
        </Paper>
      </Grid>
    </React.Fragment>
  );
}

export default SafetyEventLanding;
